var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('button',{staticStyle:{"border":"none","background":"none","margin-right":"5px"},on:{"click":function($event){return _vm.cariEkstre()}}},[_c('box-icon',{staticClass:"text-body align-middle mr-25",staticStyle:{"float":"right"},attrs:{"name":"search-alt-2","animation":"tada-hover","color":"#7367F0"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }